/**
 * Integration type enums
 */

export enum IntegrationType {
  GATEWAYAPI = 'GatewayAPI',
  BACNET="BACnet"
}
